import React from 'react';
import { styled, CountdownText } from '@teko/ui';
import { ClockAlternativeOutlined } from '@teko/ds-icon';

const TimeMessageWrapper = styled.div`
  color: white;
  text-transform: initial;
  font-weight: normal;
  text-overflow: ellipsis;
  overflow: hidden;
`;
const BoldWrapper = styled.span`
  font-weight: bold;
`;
const LargeTextWrapper = styled.span`
  margin-right: 4px;
`;
const StyledClockOutline = styled(ClockAlternativeOutlined)`
  margin-bottom: 2px;
`;
const FlashSaleBadgeTime = ({ size, endAt }) => {
  return /* @__PURE__ */ React.createElement(TimeMessageWrapper, null, size == "lg" && /* @__PURE__ */ React.createElement(LargeTextWrapper, null, /* @__PURE__ */ React.createElement(StyledClockOutline, {
    color: "#ffffff",
    size: 20
  })), /* @__PURE__ */ React.createElement(BoldWrapper, null, /* @__PURE__ */ React.createElement(CountdownText, {
    date: endAt
  })));
};

export { FlashSaleBadgeTime };
